import useTranslations from 'i18n/useTranslations';
import React from 'react'

const EmptyPromotion = () => {
    const { t } = useTranslations();
    return (
        <div class="bPromotionNone">
            <div class="bText">
            <i></i>
            <p>{t.promotionDetail.noPromotion}</p>
            </div>
        </div>
    )
}

export default EmptyPromotion